<template>
    <b-container fluid>
        <b-row>
            <b-col>
                <div class="container">
                    <div class="row">
                        <div class="col">
                            <h1>File Download</h1>
                            <div class="my-3">If your file does not download automatically please click the button below:</div>
                            <b-button
                                    @click="downloadFile"
                                    variant="primary"
                            >
                                Download
                                <font-awesome-icon :icon="['fal', 'download']"></font-awesome-icon>
                            </b-button>
                        </div>
                    </div>
                </div>

            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import User from '@/services/User/User';

export default {
  name: 'Download',
  components: {
  },
  computed: {
    clientUserDownloadId() {
      return this.$route.params.clientUserDownloadId;
    },
  },
  mounted() {
    this.downloadFile();
  },
  methods: {
    async downloadFile() {
      const { data } = await User.getDownloadInfo(this.clientUserDownloadId);

      if (!data.data.available) {
        this.$notify({
          duration: 7000,
          title: 'File not available',
          text: 'This file is not available',
          type: 'error',
        });
        return;
      }

      User.download(this.clientUserDownloadId, data.data.filename);
      return true;
    },
  },
};
</script>
<style lang="scss">
</style>
